import { PaletteColor } from '@material-ui/core/styles/createPalette';
import { Color } from '@material-ui/core';
import muiGrey from '@material-ui/core/colors/grey';

export const primary: PaletteColor = {
  contrastText: '#fff',
  dark: '#7C4672',
  light: '#fff5fd',
  main: '#8E5082',
};

export const secondary: PaletteColor = {
  contrastText: '#fff',
  dark: '#e66300',
  light: '#fffaf7',
  main: '#fa7009',
};

export const positive: PaletteColor = {
  contrastText: '#fff',
  dark: '#3e9c01',
  light: '#f3fbed',
  main: '#48b600',
};

export const negative: PaletteColor = {
  contrastText: '#fff',
  dark: '#cb302c',
  light: '#fff8f8',
  main: '#e94944',
};

export const warning: PaletteColor = {
  contrastText: '#fff',
  dark: '#f4b208',
  light: '#fffcf4',
  main: '#ffc21b',
};

export const mint: PaletteColor = {
  contrastText: '#fff',
  dark: '#00af9e',
  light: '#e6f7f5',
  main: '#00c5ba',
};

export const white: PaletteColor = {
  contrastText: '#000',
  dark: '#fff',
  light: '#fff',
  main: '#fff',
};

export const grey: Color = {
  ...muiGrey,
  50: '#f9f9f9',
  100: '#f3f4f5',
  200: '#e8ebed',
  300: '#d4d9dd',
  400: '#aab4bb',
  500: '#808f9a',
  600: '#566a79',
  700: '#2d4658',
  800: '#1B2D3A',
};
